import { useMutation } from "@apollo/client/react";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import { UPDATE_INVOICE_ROWS } from "../../mutations/invoices/updateInvoiceRows";

export const useUpdateInvoiceRows = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [updateInvoiceRows, { data, loading, error }] = useMutation(
    UPDATE_INVOICE_ROWS,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch ? [] : [GET_INVOICE_LATEST_VALIDATION_RESULT],
      awaitRefetchQueries: true,
    },
  );

  return { updateInvoiceRows, data, loading, error };
};
